module.exports = __webpack_public_path__ + "img/18.9aa4f278.jpg";